<template>
  <v-row justify="center">
    <v-col lg="6" md="8" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="editForm" v-model="valid">
          <v-card-title>
            <h2>{{ $t("admin.team.settings.zoom.title") }}</h2>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :label="$t('admin.team.settings.zoom.meetingNumber')"
              :rules="[$v.minLength(13), $v.maxLength(13)]"
              v-model="formattedZoomNumber"
            ></v-text-field>
            <v-text-field
              :label="$t('admin.team.settings.zoom.meetingCode')"
              :rules="[$v.minLength(6), $v.maxLength(6)]"
              v-model="team.zoomMeetingCode"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid" color="primary" type="submit">
              {{ $t("admin.team.settings.zoom.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      team: {},
      valid: false,
    };
  },
  mounted() {
    this.getTeamFromApi();
  },
  methods: {
    async getTeamFromApi() {
      this.loading = true;
      this.team = await axios.get(`/event/teams/${this.$route.params.teamId}`);
      this.loading = false;
    },
    async save() {
      await axios.put(`/admin/teams/${this.$route.params.teamId}`, this.team);
      this.$store.commit("SUCCESS", this.$t("admin.team.settings.advanced.msgSaved"));
    },
  },
  computed: {
    formattedZoomNumber: {
      get() {
        if (!this.team.zoomMeetingNumber) return null;
        else if (this.team.zoomMeetingNumber.length < 3) return this.team.zoomMeetingNumber.slice(0, 3);
        else if (this.team.zoomMeetingNumber.length < 7)
          return this.team.zoomMeetingNumber.slice(0, 3) + " " + this.team.zoomMeetingNumber.slice(3, 7);
        else
          return (
            this.team.zoomMeetingNumber.slice(0, 3) +
            " " +
            this.team.zoomMeetingNumber.slice(3, 7) +
            " " +
            this.team.zoomMeetingNumber.slice(7, 11)
          );
      },
      set(number) {
        const joinedNumber = number.replace(/\s/g, "");
        this.team.zoomMeetingNumber = joinedNumber;
      },
    },
  },
};
</script>

<style scoped></style>
